import { api } from '../configs/axiosConfigs'
import { defineCancelApiObject } from '../configs/axiosUtils'

export const ConfigurationService =  {
    getConfiguration: async function (configValues, cancel = false) {
        const response = await api.request({
            url: `/GetTranscriberConfigParameter`,
            method: "POST",
            data: configValues,
            signal: cancel ? cancelApiObject[this.startCall.name].handleRequestCancellation().signal : undefined,
        });
        return response.data;
    },
    saveConfiguration: async function (configValues, cancel = false) {
        const response = await api.request({
            url: `/SaveTranscriberConfigParameter`,
            method: "POST",
            data: configValues,
            signal: cancel ? cancelApiObject[this.startCall.name].handleRequestCancellation().signal : undefined,
        });
        return response.data;
    }
};

export const cancelApiObject = defineCancelApiObject(ConfigurationService);